import React, { useContext, useEffect, useState } from "react";
import { Button, ConfigProvider, Form, Modal, Select, message } from "antd";
import locale from "antd/es/locale/es_ES";
import { AuthContext } from "../../../../config/AuthContext";
import BbddColors from "../../../../styles/BbddColors";
import { GetAules } from "../../../../dao/GetAules";
import { GetBbddActivitats } from "../../../../dao/bbdd/GetBbddActivitats";
import { PostBbddPracticaIdCopy } from "../../../../dao/bbdd/PostBbddPracticaIdCopy";

interface Props {
    visible: boolean;
    onClose: (updated: boolean) => void;
}

const CopiarActivitatModal: React.FC<Props> = ({ visible, onClose }) => {
    const [form] = Form.useForm();
    const { userId, user } = useContext(AuthContext);
    const resolvedUserId = user?.id || (user as any)?.idUsuari || userId;
    const [loading, setLoading] = useState(false);
    const [aules, setAules] = useState<any[]>([]);
    const [activitats, setActivitats] = useState<any[]>([]);

    useEffect(() => {
        const loadData = async () => {
            if (visible) {
                try {
                    const fetchedAules = await GetAules(resolvedUserId + "");
                    setAules(fetchedAules || []);
                    
                    const fetchedActivitats = await GetBbddActivitats(resolvedUserId + "");
                    setActivitats(fetchedActivitats || []);
                } catch (error) {
                    console.error("Error loading data", error);
                }
            }
        };
        loadData();
    }, [visible, resolvedUserId]);

    const handleCancel = () => {
        form.resetFields();
        onClose(false);
    };

    const submitData = async (values: any) => {
        try {
            setLoading(true);
            const { idPrac, idAulaDesti } = values;
            await PostBbddPracticaIdCopy(idPrac, { id_aula: idAulaDesti });
            message.success("Activitat copiada correctament");
            form.resetFields();
            onClose(true);
        } catch (err) {
            console.error(err);
            message.error("Error copiant l'activitat");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Copiar Activitat"
                open={visible}
                onCancel={handleCancel}
                footer={null}
            >
                <hr />
                <Form
                    form={form}
                    onFinish={submitData}
                    layout="vertical"
                >
                    <Form.Item
                        label="Activitat a copiar"
                        name="idPrac"
                        rules={[{ required: true, message: "Selecciona una activitat" }]}
                    >
                        <Select
                            showSearch
                            placeholder="Selecciona una activitat existent"
                            optionFilterProp="label"
                            options={activitats.map(act => ({
                                value: act.id,
                                label: `${act.nom} (Aula ${act.id_aula} - ${act.aula || ''})`
                            }))}
                            filterOption={(input, option) =>
                                (option?.label as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>

                    <Form.Item
                        label="Aula de destí"
                        name="idAulaDesti"
                        rules={[{ required: true, message: "Selecciona l'aula de destí" }]}
                    >
                        <Select
                            showSearch
                            placeholder="Selecciona l'aula on es copiarà"
                            optionFilterProp="label"
                            options={aules.map(aula => ({
                                value: aula.id,
                                label: aula.nom
                            }))}
                            filterOption={(input, option) =>
                                (option?.label as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>

                    <div style={{ textAlign: "right", marginTop: 24 }}>
                        <Button onClick={handleCancel} style={{ marginRight: 10 }}>
                            Cancel·lar
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            style={{ backgroundColor: BbddColors.colors.color6, border: "none" }}
                        >
                            Copiar
                        </Button>
                    </div>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default CopiarActivitatModal;
